import React from 'react';
import '../css/Ourfleet.css';
import { Helmet } from 'react-helmet';

const Ourfleet = () => {
  const bookingData = [
    {
      id: 1,
      imgSrc: '/images/ourfleet/1.jpg',
      title: 'Swift Desire',
      description: 'Perfect for city rides and short trips with comfort. S9 Travels provides a seamless, hassle-free experience for quick city commutes or day trips.',
    },
    {
      id: 2,
      imgSrc: '/images/ourfleet/2.jpg',
      title: 'Ertiga',
      description: 'Spacious and ideal for family trips and off-road adventures. S9 Travels offers an ideal choice for families who want comfort on both urban roads and rugged terrains.',
    },
    {
      id: 3,
      imgSrc: '/images/ourfleet/4.jpg',
      title: 'Innova Crysta',
      description: 'Enjoy a premium experience with our luxury urbania. S9 Travels delivers top-tier comfort and style for those seeking an elevated travel experience.',
    },
    {
      id: 4,
      imgSrc: '/images/ourfleet/5.jpg',
      title: 'Kia Carens',
      description: 'Ideal for group travel, offering ample space and comfort. With S9 Travels, experience comfortable group travel with excellent amenities, making your journey memorable.',
    },
    {
      id: 5,
      imgSrc: '/images/ourfleet/in.jpg',
      title: 'Innova Cab',
      description: 'Perfect for larger groups, providing great comfort. S9 Travels Innova Cabs are the perfect choice for a comfortable and convenient group travel experience.',
    },
    {
      id: 6,
      imgSrc: '/images/ourfleet/3.jpg',
      title: 'Scorpio',
      description: 'For those seeking extra space and amenities on long trips. With S9 Travels, the Scorpio provides exceptional comfort and is designed to tackle both short and long-distance journeys effortlessly.',
    },
    {
      id: 7,
      imgSrc: '/images/ourfleet/7.jpg',
      title: 'Tempo Traveller',
      description: 'For those needing extra space and comfort on group trips, the Tempo Traveller by S9 Travels offers a spacious and cozy ride, perfect for longer journeys with friends or family.',
    },
    {
      id: 8,
      imgSrc: '/images/ourfleet/8.jpg',
      title: 'Mini Bus',
      description: 'The Mini Bus by S9 Travels ensures a comfortable and spacious ride, ideal for group travels. With ample seating and modern amenities, it is perfect for long journeys, family trips, or corporate outings.',
    },
    {
      id: 9,
      imgSrc: '/images/ourfleet/9.jpg',
      title: 'Luxury Bus',
      description: 'The Luxury Bus by S9 Travels offers a premium travel experience with spacious seating and top-tier amenities, perfect for long journeys in comfort and style.',
    },
    {
      id: 10,
      imgSrc: '/images/ourfleet/10.webp',
      title: 'Urbania ',
      description: 'For those seeking extra space and amenities on long trips. S9 Travels offers the Luxury Bus, a perfect blend of comfort, luxury, and practicality for group travel.',
    },
    {
      id: 11,
      imgSrc: '/images/ourfleet/12.webp',
      title: '35 Seater Bus',
      description: 'The 35 Seater Bus by S9 Travels provides ample space and comfort for medium-sized groups, making it an excellent choice for smooth and enjoyable long-distance travel.',
    },
    {
      id: 12,
      imgSrc: '/images/ourfleet/13.jpg',
      title: 'Volvo Bus',
      description: 'The Volvo Bus by S9 Travels offers luxury and comfort, with plush seating and advanced amenities, ensuring a premium travel experience for long-distance journeys.',
    },
  ];
  

  const productSchema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Pune to Mumbai Cab",
    "description": "Book your comfortable Pune to Mumbai cab for a smooth and hassle-free journey. Choose from one-way, round trip, and group travel options with both affordable and luxury cabs.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.7",
      "ratingCount": "450"
    }
  };
  return (
    <div>



          <Helmet>
              <title>Pune to Mumbai Cab | S9 Travels | Call: +91 8850328441</title>
              <meta 
                name="description" 
                content="Book a reliable cab for your Pune to Mumbai journey. Affordable and luxury cabs available for one-way, round-trip, and group travel services." 
              />
              {/* Inject JSON-LD Schema */}
              <script type="application/ld+json">
                {JSON.stringify(productSchema)}
              </script>
            </Helmet>
      
     <section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1> Our fleets</h1>
        </div>
      </div>
    </section>




      <section className="our-booking">
        <div className="container">
          {/* <h2 className='section-title'>Explore Our Fleet</h2> */}
          <div className="row g-4">
            {bookingData.map(booking => (
              <div key={booking.id} className="col-12 col-md-6 col-lg-4">
                <div className="card booking-card">
                  <div className="card-image">
                    <img src={booking.imgSrc} className="card-img-top" alt={booking.title} />
                  </div>
                  <div className="card-content">
                    <div className="content-border">
                      <h3 className="card-title">{booking.title}</h3>
                      <p className="card-description text-white">{booking.description}</p>
                      <a href="https://wa.me/918850328441" target="_blank" rel="noopener noreferrer">
    {/* <button className="btn btn-primary">Book Now</button> */}
</a>

                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Ourfleet;
